require("!!/var/www/robins-and-day-website/node_modules/script-loader/addScript.js")(require("!!/var/www/robins-and-day-website/node_modules/raw-loader/index.js!/var/www/robins-and-day-website/resources/assets/js/modernizr/svg-animations.exec.js"))


// WEBPACK FOOTER //
// ./resources/assets/js/modernizr/svg-animations.exec.js